import { render, staticRenderFns } from "./ContactsView.vue?vue&type=template&id=02f54c9c&lang=pug"
import script from "./ContactsView.vue?vue&type=script&lang=ts"
export * from "./ContactsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02f54c9c')) {
      api.createRecord('02f54c9c', component.options)
    } else {
      api.reload('02f54c9c', component.options)
    }
    module.hot.accept("./ContactsView.vue?vue&type=template&id=02f54c9c&lang=pug", function () {
      api.rerender('02f54c9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contacts/Contacts/ContactsView.vue"
export default component.exports